import React from "react";
import { IconButton } from "@mui/material";
import { ModeEditOutlineTwoTone } from "@mui/icons-material";

import AppTable from "components/Shared/AppTable";

const RouteShipmentStopsList = ({ stops, isLoading, onEdit }) => {
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      cell: (row, index) => index + 1,
      width: "60px"
    },
    {
      name: "Origin",
      selector: (row) => row?.stopOrigin?.name,
      cell: (row) =>
        row?.stopOrigin?.name
          ? `${row.stopOrigin.name} - ${row.stopOrigin.code}`
          : "N/A",
    },
    {
      name: "Destination",
      selector: (row) => row?.stopDestination?.name,
      cell: (row) =>
        row?.stopDestination?.name
          ? `${row.stopDestination.name} - ${row.stopDestination.code}`
          : "N/A",
    },
    {
      name: "Distance (km)",
      selector: (row) => row?.stopDistance,
      cell: (row) => row?.stopDistance ?? "N/A",
    },
    {
      name: "Time (min)",
      selector: (row) => row?.stopTime,
      cell: (row) => row?.stopTime ?? "N/A",
    },
    {
      name: "Cost",
      selector: (row) => row?.stopCost,
      cell: (row) => row?.stopCost ?? "N/A",
    },
    {
      name: "Actions",
      cell: (row) => (
        <IconButton
          size="small"
          onClick={() => onEdit(row)}
          aria-label="Edit Stop"
        >
          <ModeEditOutlineTwoTone />
        </IconButton>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  return (
    <AppTable
      columns={columns}
      data={stops}
      progressPending={isLoading}
      noDataComponent={
        <div className="p-4 text-gray-500">No stops available for this route.</div>
      }
      dense
      pagination={false}
    />
  );
};

export default RouteShipmentStopsList;
